import React, { useState, useEffect } from "react"
import Slider from "react-slick"
import { Link } from "gatsby";

const SliderHome = ({ sliders }) => {
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000
    }
    const slider = sliders && [...sliders];
    return (
        <Slider {...settings}>
            {slider.map((res, index) => {
                console.log('res', res);
                return (
                    <div key={index} className="slide-list ">
                        <div className={res.Theme}>
                            <div className="text col-md-7">
                                <h2>{res && res.titre}</h2>
                                <h3>{res && res.sous_titre}</h3>
                                <p>
                                    {res && res.description}
                                </p>
                                {/* <a className="btn white" href={res && res.link}>Decouvrir</a> */}
                                <Link className="btn white" to={res && res.link}>
									Decouvrir
								</Link>
                            </div>
                            <div className="image">
                                {
                                    res.images_item?.data?.attributes && <img src={`${process.env.GATSBY_API_URL_FILE}`+res.images_item.data.attributes.url} alt="test" />
                                }
                            </div>
                        </div>

                    </div>
                )

            })}
        </Slider>
    )
}

export default SliderHome;